import React from "react";
import "./Model.css";
import CloseIcon from "@mui/icons-material/Close";

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal_overlay" onClick={onClose}>
      <div className="modal_container" onClick={(e) => e.stopPropagation()}>
        <button className="modal_close_btn" onClick={onClose}>
          <CloseIcon />
        </button>
        <div className="modal_content">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
